import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import type { Props, State } from './GlobalFieldsTourSteps.types.tsx';
import { CARD_COVERS_SPOTLIGHT } from './cardCoversSpotlight.constants.tsx';

export const setCardCoverSpotlightDismissed =
	(spotlightDismissed: boolean): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		const state = getState();
		const newCardCoverSpotlightState = {
			spotlightDismissed,
		};

		setState({
			...state,
			cardCoverSpotlight: newCardCoverSpotlightState,
		});

		try {
			await setUserProperties(accountId, CARD_COVERS_SPOTLIGHT, JSON.stringify(spotlightDismissed));
		} catch (error) {
			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.card-cover-spotlight',
				`Failed to set user property with key: ${CARD_COVERS_SPOTLIGHT}`,
				error instanceof Error ? error : new Error(String(error)),
			);
		}
	};
